import React, { ReactElement } from 'react';
import Head from 'next/head';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from '../Footer';
import Header from '../Header/';

interface ILayout {
  children: React.ReactElement;
  title?: string;
  description?: string;
}

function Layout({ children }: ILayout) {
  const { title, description } = children.props;

  return (
    <>
      <Head>
        <title>{!title ? 'Вопросы и ответы онлайн | Учи.Ответы' : title}</title>
        <meta
          name="description"
          content={
            !description
              ? 'Задай вопрос онлайн и получи ответ на Учи.Ответы'
              : description
          }
          key="desc"
        />
        <meta
          property="og:description"
          content={
            !description
              ? 'Задай вопрос онлайн и получи ответ на Учи.Ответы'
              : description
          }
        />
        <meta
          property="og:image"
          content="https://uchi.ru/countries/russia/preview_image.png"
        />
        <meta property="og:locale" content="ru_RU" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Учи.Ответы" />
        <link
          rel="shortcut icon"
          type="image/x-icon"
          href="https://uchi.ru/otvety/favicon.ico"
        />
      </Head>
      <>
        <div className="body" id="body">
          <Header />
          {children}
          <Footer />
        </div>
        <ToastContainer
          position="top-right"
          limit={2}
          autoClose={6000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </>
    </>
  );
}

export const getLayout = (page: ReactElement) => <Layout>{page}</Layout>;

export default Layout;
